import * as r from 'ramda';
import uuid from 'uuid/v4';

const querify = r.pipe(
  r.toPairs,
  r.map(
    r.pipe(
      r.unless(
        r.propSatisfies(r.isNil, '1'),
        r.adjust(1, encodeURIComponent),
      ),
      r.join('='),
    ),
  ),
  r.join('&'),
);

export default function createSendAnalytics(navigator) {
  return function sendAnalytics(opts) {
    const data = querify({
      v: 1,
      t: 'event',
      tid: CONFIG.analytics.tracker,
      cid: uuid(),
      aip: 1,
      dp: window.location.pathname,
      ...opts,
    });

    if (navigator.sendBeacon != null) {
      try {
        navigator.sendBeacon('https://www.google-analytics.com/collect', data);
      } catch(e) {
        // failed to send beacon
        // this only seems to happen in unique circumstances:
        // navigator.sendBeacon is not supported by the browser (aka IE/Edge)
        // the user has disabled anlytics stuff (i.e. setting strict privacy security in Edge)
        // polyfill.io's sendBeacon will throw a sync error if it fails to transmit the request
        // meaning that the callee will also throw. If called from an epic (so, like, 100% of the time)
        // the epic will fall over and the entire epic system will die
      }
    }
  };
}
